// 滚动条最小高度
export const MIN_SCROLL_BAR_HEIGHT = 32;
